import { ROLE_PERMISSIONS, ROLE_READER } from "../auth/permissions";

export interface CompanyUser {
  id?: number;
  userId?: number;
  companyId?: number;
  role?: string;
  permissions?: string[];
  email?: string;
  firstName?: string;
  lastName?: string;
  password1?: string;
  password2?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const newCompanyUser = (): CompanyUser => {
  return {
    id: undefined,
    userId: undefined,
    companyId: undefined,
    role: ROLE_READER,
    permissions: ROLE_PERMISSIONS[ROLE_READER],
    email: "",
    firstName: "",
    lastName: "",
  };
};

export default CompanyUser;
